import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Stepper from '@mui/material/Stepper';

import type { EstadoDaFonte } from '../api/tipos';

const PASSOS = ['Documento lido', 'Regras propostas', 'Sua revisão', 'Ativa'] as const;

/** Quantos passos já terminaram em cada estado; o passo seguinte é o atual. A fonte rejeitada não tem trilha. */
const PASSOS_CONCLUIDOS: Record<Exclude<EstadoDaFonte, 'rejeitada'>, number> = {
  recebida: 0,
  texto_extraido: 1,
  mapeada: 1,
  regras_extraidas: 2,
  em_revisao: 2,
  ativa: PASSOS.length,
};

/** Onde esta fonte está no caminho até valer: a forma responde "onde estou" sem um parágrafo. */
export function PassosDaRevisao({ estado }: { estado: EstadoDaFonte }): React.JSX.Element | null {
  if (estado === 'rejeitada') return null;
  const concluidos = PASSOS_CONCLUIDOS[estado];

  return (
    <Stepper activeStep={concluidos} alternativeLabel aria-label="Etapas da fonte">
      {PASSOS.map((rotulo, indice) => (
        <Step key={rotulo} completed={indice < concluidos}>
          <StepLabel>{rotulo}</StepLabel>
        </Step>
      ))}
    </Stepper>
  );
}
